export default __webpack_public_path__ + "static/media/img-survey-soon.2885b7fc.svg";